import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.response.use(undefined, (err) => {
  const url = err?.config?.url || "";
  if (err?.response?.status === 401 && !url.includes("/auth/")) {
    window.dispatchEvent(new Event("auth:expired"));
    return new Promise(() => {});
  }
  return Promise.reject(err);
});

export default api;

export function formatErr(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Erreur inconnue";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return JSON.stringify(d);
}

export function fmtMoney(v, currency = "EUR", locale) {
  if (v == null) return "—";
  const n = Number(v);
  const loc = locale || (typeof localStorage !== "undefined" && localStorage.getItem("editionspro.lang") === "en" ? "en-US" : "fr-FR");
  return new Intl.NumberFormat(loc, { style: "currency", currency, maximumFractionDigits: 2 }).format(n);
}

export function fmtNumber(v, locale) {
  if (v == null) return "—";
  const loc = locale || (typeof localStorage !== "undefined" && localStorage.getItem("editionspro.lang") === "en" ? "en-US" : "fr-FR");
  return new Intl.NumberFormat(loc).format(Number(v));
}

export function fmtDate(v) {
  if (!v) return "—";
  const s = String(v);
  if (/^\d{4}-\d{2}$/.test(s)) return `${s.slice(5, 7)}/${s.slice(0, 4)}`;
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return `${s.slice(8, 10)}/${s.slice(5, 7)}/${s.slice(0, 4)}`;
  return s;
}

export const fmtPeriod = (ps, pe) => (ps && pe ? `${fmtDate(ps)} → ${fmtDate(pe)}` : ps || pe ? fmtDate(ps || pe) : "—");
